import { ISelectComPesquisaProps, SelectComPesquisa } from "@/Components/SelectComPesquisa";
import { ContaProvedorConciliacaoLista } from "@/Models/Financeiro/Conta";

export interface IProvedorPgtoSelectProps extends Omit<ISelectComPesquisaProps, "options"> {
    emptyOption?:any;
}
export default function ProvedorPgtoSelect({
    allowClear,
    placeholder,
    emptyOption,
    ...props
}:IProvedorPgtoSelectProps) {
    return <SelectComPesquisa
        {...props}
        allowClear={allowClear ?? true}
        placeholder={placeholder ?? "Selecione um Provedor"}
        options={[
            emptyOption,
            ...ContaProvedorConciliacaoLista
        ].filter(f => f !== undefined)}
    />;
}